<script lang="ts">
  /**
   * A run of checks in flight: where it is, and the way to stop it.
   *
   * The header and the library footer both show it; it renders nothing when
   * nothing is running.
   */
  import { game } from '../state/game.svelte';
</script>

{#if game.progress}
  <span class="progress">
    checking {game.progress.levelId} · {game.progress.index}/{game.progress.total}
  </span>
  <button class="stop" onclick={() => game.cancel()}>Stop</button>
{/if}

<style>
  .progress {
    font-family: var(--mono);
    font-size: 12px;
    color: var(--text-dim);
    white-space: nowrap;
  }

  .stop {
    padding: 3px 9px;
    font-size: 12px;
    background: none;
    white-space: nowrap;
  }
</style>
